import axios from 'axios';

import ProvinciaTabla from '../types/ProvinciaTabla';


async function GuardarProvincia(prmProvincia: ProvinciaTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_provincia"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "provincia": {
                "id": prmProvincia.id,
                "provincia": prmProvincia.provincia,
                "habilitado": prmProvincia.habilitado,
                "fch_crea": prmProvincia.fch_crea,
                "fch_modi": prmProvincia.fch_modi,
                "dado_baja": prmProvincia.dado_baja,
                "fch_baja": prmProvincia.fch_baja,
                "id_pais": prmProvincia.pais_id
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarProvincia;